import moment from "moment";

// คำนวณวันคงเหลือของบัญชี
export const calculateAccountRemainingDays = (data) => {
  const createdAt = data?.created_at;
  const limitDays = 120;
  if (!createdAt) {
    return 0;
  }
  const createdDate = moment(createdAt);
  const now = moment();
  const usedDays = now.diff(createdDate, "days");
  const remainingDays = limitDays - usedDays;
  return remainingDays >= 0 ? remainingDays : 0;
};

// คำนวณการใช้งานบัญชี
/**
 * คำนวณการใช้งานบัญชีและแสดงผลในหน่วยที่เหมาะสม (วัน, ชั่วโมง, นาที)
 * @param {object} data - ข้อมูลบัญชีที่มี created_at
 * @returns {string} - ข้อความแสดงระยะเวลาการใช้งาน
 */
export const calculateAccountUsage = (data) => {
  const createdAt = data?.created_at;
  if (!createdAt) {
    return "ไม่พบข้อมูล";
  }

  const createdDate = moment(createdAt);
  const now = moment();

  // ตรวจสอบว่า createdDate อยู่ในอดีตหรือไม่
  if (createdDate.isAfter(now)) {
    return "หมดอายุแล้ว";
  }

  const usedDays = now.diff(createdDate, "days");

  if (usedDays >= 1) {
    return `${usedDays}`;
  }

};
